module.exports = __webpack_public_path__ + "img/bin.4b850cb6.png";